import { get } from 'lodash'
import React from 'react'
import { TableRowProps } from 'react-virtualized'
import styled from 'styled-components'

import Tooltip from '../../Tooltip'
import Loader from './Loader'

type TWrapper = {
  first?: boolean
  last?: boolean
  endofgroup?: boolean
  isMarked?: boolean
  isHovered?: boolean
  canBeHovered?: boolean
  even?: boolean
  level?: number
}
const Wrapper = styled.div<TWrapper>`
  display: flex;
  align-items: center;
  padding: 3px 5px;
  border-top: ${(props) => (!props.first ? 1 : 0)}px solid #ebeff2;
  border-bottom: ${(props) => (props.last ? 1 : 0)}px solid #ebeff2;
  border-right: ${(props) => (props.endofgroup ? 2 : 1)}px solid #ebeff2;
  background: ${(props) =>
    props.isMarked
      ? '#E1F5FE'
      : props.isHovered
      ? '#f4f8fb'
      : props.even
      ? ''
      : '#f9f9f9'};
  cursor: ${({ canBeHovered }) => (canBeHovered ? 'pointer' : '')};

  padding-left: ${({ level = 0 }) => 5 + level * 20}px;

  &:hover {
    background: ${({ canBeHovered, isMarked }) =>
      canBeHovered && !isMarked ? '#f4f8fb' : ''};
  }
`

const LoaderWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
`

interface TRow extends TableRowProps {
  isMarked?: boolean
  canBeHovered?: boolean
  rowStyle?: React.CSSProperties
  level?: number
  popover?: React.ReactNode
}
const Row = (props: TRow): React.ReactElement => {
  const {
    columns,
    index,
    key,
    className,
    style,
    isMarked,
    canBeHovered,
    rowData,
    onRowClick,
    rowStyle = {},
    level = 0,
    popover,
  } = props

  const onClick = (): void => {
    const id = get(rowData, 'id')
    if (id && onRowClick) {
      onRowClick(id)
    }
  }

  return (
    <Tooltip element={popover} isPopover>
      <Wrapper
        canBeHovered={canBeHovered}
        onClick={onClick}
        style={{ ...style, ...rowStyle }}
        isMarked={isMarked}
        key={key}
        className={className}
        even={index % 2 === 0}
        level={level}
      >
        {columns}
        {!rowData && (
          <LoaderWrapper>
            <Loader />
          </LoaderWrapper>
        )}
      </Wrapper>
    </Tooltip>
  )
}

export default Row
